import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import {MatDialogRef} from '@angular/material/dialog';

@Component({
  selector: 'warranty-help-dialog',
  templateUrl: './warranty-help-dialog.component.html',
  styleUrls: ['./warranty-help-dialog.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true
})
export class WarrantyHelpDialogComponent {
  readonly dialogRef = inject<MatDialogRef<WarrantyHelpDialogComponent>>(MatDialogRef);

}
